var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"max-w-5xl mx-auto text-center py-4"},[_c('p',{staticClass:"font-bold text-[2.62vw] md:text-lg Helvetica"},[_vm._v(" Pour votre santé, mangez au moins cinq fruits et légumes par jour. www.mangerbouger.fr ")]),_c('p',{staticClass:"text-[2.1vw] sm:text-xs sm:py-2"},[_vm._v(" © Ferrero 2025. TOUS DROITS RÉSERVÉS ")])])])
}]

export { render, staticRenderFns }